import _ from 'lodash';
import { FC, useEffect, useState } from 'react';
import PortalToTarget from '../PortalToTarget';

const TelegramPopUp: FC = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const lastModalDate = localStorage.getItem('telegramPopupLastModalDate');

    const storedDate = lastModalDate ? new Date(lastModalDate) : null;
    const lastWeek = new Date();
    lastWeek.setDate(lastWeek.getDate() - 7);

    if (_.isEmpty(lastModalDate) || (storedDate && storedDate < lastWeek)) {
      setShowModal(true);
    }
  }, []);

  return (
    showModal && (
      <PortalToTarget targetClassName="support-content" allowForWeb className="p-0">
        {/* <div className="support-content__telegram">
          <a href="https://t.me/quantman1" target="_blank" rel="noopener noreferrer">
            <img src="/telegram.svg" alt="telegram" className="telegram-img" />
            <span>Join us on telegram</span>
          </a>
        </div> */}
      </PortalToTarget>
    )
  );
};

export default TelegramPopUp;
